/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVendorWorkspaceApproveLogDto } from '../../models/create-vendor-workspace-approve-log-dto';
import { VendorWorkspaceApproveLogDto } from '../../models/vendor-workspace-approve-log-dto';

export interface VendorWorkspaceApproveLogControllerCreate$Params {
      body: CreateVendorWorkspaceApproveLogDto
}

export function vendorWorkspaceApproveLogControllerCreate(http: HttpClient, rootUrl: string, params: VendorWorkspaceApproveLogControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceApproveLogDto>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceApproveLogControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorWorkspaceApproveLogDto>;
    })
  );
}

vendorWorkspaceApproveLogControllerCreate.PATH = '/api/vendorWorkspaceApproveLog';
